import { IConfigInterface } from "@gwn/guac-lib";
import * as Sentry from "@sentry/browser";

/**
 *  Configuration interaface that shares the GUAC-core config with the microfrontends
 */
export const configInterface: IConfigInterface = {
  drsUrl: process.env.GUAC_DRS_URL ?? "",
  environment: process.env.NODE_ENV ?? "",
  version: process.env.npm_package_version ?? "",
};

export const isProductionEnvironment = (env: string) => {
  return env === "production" || env === "gov" || env === "gov-test";
};

export const initSentry = () => {
  const dsn = process.env.GUAC_SENTRY_DSN;
  const environment = process.env.GUAC_ENVIRONMENT;
  const sampleRate = parseInt(process.env.GUAC_SENTRY_SAMPLERATE);
  const sentryReplayEnabled = process.env.GUAC_SENTRY_REPLAY_ENABLED === "true";
  if (dsn && environment !== "local") {
    const client = new Sentry.BrowserClient({
      dsn: dsn,
      integrations: [...Sentry.defaultIntegrations],
      transport: Sentry.makeFetchTransport,
      stackParser: Sentry.defaultStackParser,
      replaysOnErrorSampleRate: 1.0,
      replaysSessionSampleRate: 0,
      tracesSampleRate: sampleRate,
      release: process.env.npm_package_version,
      environment: environment,
    });
    const hub = new Sentry.Hub(client);
    Sentry.makeMain(hub);

    if (sentryReplayEnabled) {
      const replay = new Sentry.Replay();
      client.addIntegration(replay);
    }

    return hub;
  }

  return null;
};

export const sentry = initSentry();
